'use client';

import { useRouter } from 'next/navigation';

/** The same consent event and compatibility fallback as Core's cookie FAB. */
export function CookiePreferencesButton() {
  const router = useRouter();

  function openPreferences() {
    const detail = { handled: false };
    window.dispatchEvent(new CustomEvent('eliadmin:open-cookie-preferences', { detail }));
    if (detail.handled) return;

    const query = new URLSearchParams(window.location.search);
    query.set('occ', 'true');
    router.push(`${window.location.pathname}?${query.toString()}${window.location.hash}`);
  }

  return (
    <button type="button" onClick={openPreferences} className="text-xs underline sm:text-sm">
      Nastavenia cookies
    </button>
  );
}
